import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
function _createForOfIteratorHelper(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (!it) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = it.call(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it["return"] != null) it["return"](); } finally { if (didErr) throw err; } } }; }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import config from "../config";
import { v4 as uuidV4 } from 'uuid';
var env = 'test';
var UUID = uuidV4().substr(0, 8);
setEnv(process.env.CHEGG_ENV);
export { recordEvents, setEnv };
export function getNrUUID() {
  return UUID;
}
export var EventTypes = /*#__PURE__*/function (EventTypes) {
  EventTypes["init"] = "init";
  EventTypes["loginStart"] = "login_start";
  EventTypes["loginSent"] = "login_request_sent";
  EventTypes["loginFail"] = "login_error";
  EventTypes["loginServerError"] = "login_server_error";
  EventTypes["loginSuccess"] = "login_success";
  EventTypes["ssoLoginSent"] = "sso_login_request_sent";
  EventTypes["ssoLoginFail"] = "sso_login_error";
  EventTypes["oneAuthSocialLoginFail"] = "oneauth_social_login_fail";
  EventTypes["ssoLoginSuccess"] = "sso_login_success";
  EventTypes["mfaRequired"] = "mfa_challenge_required";
  EventTypes["sendEmailStart"] = "mfa_sent_email_request";
  EventTypes["sendEmailEnd"] = "mfa_sent_email_success";
  EventTypes["sendEmailFail"] = "mfa_sent_email_error";
  EventTypes["signupStart"] = "signup_start";
  EventTypes["signupSent"] = "signup_request_sent";
  EventTypes["signupFail"] = "signup_error";
  EventTypes["signupServerError"] = "signup_server_error";
  EventTypes["signupSuccess"] = "signup_success";
  EventTypes["ssoSignupSent"] = "sso_signup_request";
  EventTypes["ssoSignupFail"] = "sso_signup_error";
  EventTypes["ssoSignUpSuccess"] = "sso_signup_success";
  EventTypes["resetPasswordStart"] = "reset_password_request";
  EventTypes["resetPasswordFail"] = "reset_password_error";
  EventTypes["resetPasswordSuccess"] = "reset_password_success";
  EventTypes["checkIfEmailTakenFail"] = "check_if_email_taken_error";
  EventTypes["mfaInactiveUser"] = "mfa_inactive_user";
  EventTypes["invalidMfaCode"] = "invalid_mfa_code_entered";
  EventTypes["sendRioEventFail"] = "send_rio_event_fail";
  EventTypes["pxCaptchaFailed"] = "px_captcha_failed";
  EventTypes["pxCaptchaSuccess"] = "px_captcha_success";
  EventTypes["pxCaptchaDisplayed"] = "px_captcha_displayed";
  EventTypes["popupBlocked"] = "social_popup_blocked";
  EventTypes["messageReceived"] = "social_message_received";
  EventTypes["socialClicked"] = "social_clicked";
  EventTypes["unknownError"] = "unknown_error";
  EventTypes["oneTapDisplayed"] = "one_tap_displayed";
  EventTypes["oneTapDismissed"] = "one_tap_dismissed";
  EventTypes["oneTapSuccess"] = "one_tap_success";
  EventTypes["oneTapError"] = "one_tap_error";
  return EventTypes;
}({});
function setEnv(newEnv) {
  if (!newEnv || !config[newEnv]) {
    return;
  }
  env = newEnv;
}
function recordCustomEvent(eventType, eventData) {
  var _config$env = config[env],
    newRelicKey = _config$env.newRelicKey,
    newRelicAccountNumber = _config$env.newRelicAccountNumber,
    newRelicUrl = _config$env.newRelicUrl;
  var url = "".concat(newRelicUrl).concat(newRelicAccountNumber, "/events");
  var data = _objectSpread({
    env: env,
    eventType: eventType,
    callTimestamp: Date.now(),
    userAgent: window.navigator.userAgent
  }, eventData);
  var nrEventBody = JSON.stringify(data);
  return fetch(url, {
    method: 'POST',
    cache: 'no-cache',
    headers: {
      'Content-Type': 'application/json',
      'X-insert-Key': newRelicKey
    },
    body: nrEventBody
  });
}
function recordEvents(map) {
  Object.keys(map).forEach(async function (name) {
    try {
      await recordCustomEvent('OneAuthEvent', _objectSpread(_objectSpread({
        EventName: name,
        SourcePage: window.location.href,
        website: window.location.host,
        path: window.location.pathname,
        uuid: UUID,
        // @ts-ignore
        version: typeof window !== 'undefined' ? window.__oneauthVersion : 'unknown'
      }, getSessionIds()), map[name]));
    } catch (error) {
      console.error(error);
    }
  });
}
var $visitorId;
var $sessionId;
function getSessionIds() {
  if (!$sessionId) {
    var visitorId = 'unknown';
    var sessionId = 'unknown';
    var cookies = document.cookie.split(';');
    var _iterator = _createForOfIteratorHelper(cookies),
      _step;
    try {
      for (_iterator.s(); !(_step = _iterator.n()).done;) {
        var cookie = _step.value;
        var _cookie$trim$split = cookie.trim().split('='),
          _cookie$trim$split2 = _slicedToArray(_cookie$trim$split, 2),
          name = _cookie$trim$split2[0],
          value = _cookie$trim$split2[1];
        if (name.toLowerCase() == 'csessionid') {
          sessionId = value;
        }
        if (name.toLowerCase() == 'cvid') {
          visitorId = value;
        }
      }
    } catch (err) {
      _iterator.e(err);
    } finally {
      _iterator.f();
    }
    $visitorId = visitorId;
    $sessionId = sessionId;
  }
  return {
    CSessionID: $sessionId,
    CVID: $visitorId
  };
}